import { Scale } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BUSINESS } from "@/lib/constants";

export const Disclaimer = () => (
  <section data-testid="disclaimer-section" className="bg-[#0E0E12] py-14 lg:py-20">
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="rounded-2xl border border-white/10 bg-[#141419] p-7 sm:p-10">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#17171C] shadow-sm">
              <Scale className="h-5 w-5 text-[#D8B54A]" strokeWidth={1.8} />
            </span>
            <h2 className="font-heading text-xl font-bold tracking-tight text-[#F2EEE3] sm:text-2xl" data-testid="disclaimer-heading">
              Educational Disclaimer
            </h2>
          </div>
          <div className="mt-5 space-y-4 text-sm leading-relaxed text-[#B8B2A6]">
            <p>
              {BUSINESS.name} provides educational information, mentorship and general strategic
              guidance. Information provided by {BUSINESS.shortName} should not be considered legal,
              tax, investment or individualized financial advice.
            </p>
            <p>
              Credit reporting, credit scores, lending requirements and financing decisions are
              controlled by third parties. Results vary based on individual circumstances.
            </p>
            <p>
              {BUSINESS.shortName} does not guarantee credit score increases, removal of information
              from credit reports, financing approvals, funding amounts, interest rates or specific
              financial outcomes.
            </p>
            <p>
              Users should independently evaluate financial products and consult appropriately
              licensed professionals when necessary.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
